import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ErrorMessage } from './error-message.interface';
import { HttpError } from './http-error';

@Injectable()
export class HttpErrorHandlingService {
    getErrorMessageObject(error: unknown): ErrorMessage {
        if (error instanceof HttpErrorResponse) {
            switch (error.status) {
                case HttpError.NotFound:
                    return {
                        error: 'NOT_FOUND',
                    };
                case HttpError.Forbidden:
                    return {
                        error: 'NOT_SHARED',
                    };
                case HttpError.TooManyRequests:
                    return {
                        error: 'TOO_MANY_REQUESTS',
                    };
                case HttpError.InternalServerError:
                    return {
                        error: 'INTERNAL_SERVER_ERROR',
                    };
                default:
                    return {
                        error: 'OTHER',
                    };
            }
        } else {
            return {
                error: 'OTHER',
            };
        }
    }
}
